// extracted by mini-css-extract-plugin
export var box = "_3z-0";
export var check = "_3z-1";
export var checkboxButton = "_3z-6";
export var checkboxGroup = "_3z-5";
export var disabled = "_3z-7";
export var ghost = "_3z-9";
export var input = "_3z-2";
export var label = "_3z-4";
export var normal = "_3z-8";
export var uncheck = "_3z-3";